import React from 'react';
import SolutionsHero from '../components/solutions/SolutionsHero';
import SolutionStrategies from '../components/solutions/SolutionStrategies';
import CognitiveBehaviour from '../components/solutions/CognitiveBehaviour';
import CognitiveTalent from '../components/solutions/CognitiveTalent';
import CognitiveAcademic from '../components/solutions/CognitiveAcademic';
import CognitiveCorporate from '../components/solutions/CognitiveCorporate';
import CognitiveHuman from '../components/solutions/CognitiveHuman';
import CognitiveSports from '../components/solutions/CognitiveSports';
import CognitiveCoeporate from '../components/solutions/CognitiveCoeporate';
import Header from '../components/Header';
import WhyChooseCognitivePrism from '../components/solutions/WhyChooseCognitivePrism';
import LetsWorkTogether from '../components/solutions/LetsWorkTogether';

const Solutions = () => {
	return (
        <>
        <Header />
		<div className="min-h-screen">
			<SolutionsHero />
			<SolutionStrategies />
            <CognitiveBehaviour />
            <CognitiveTalent />
            <CognitiveAcademic />
            <CognitiveHuman />
            <CognitiveCorporate />
            <CognitiveSports />
            {/* <CognitiveCoeporate /> */}
            <WhyChooseCognitivePrism />
            <LetsWorkTogether />
		</div>
        </>
	);
};

export default Solutions;
